import React from 'react';

import ReportFish from './assets/TimeToReport.svg';
import { DisplayTemplate } from './display-results-template';

export const TimeToReportFishesTemplate = () => {
  return (
    <DisplayTemplate
      image={ReportFish}
      title="  Nice! Don't forget to submit result"
      subtitle="Click the submit button, and the fishing report will be prepared."
    />
  );
};
